var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.773,
    height: 31.989,
    viewBox: "0 0 36.773 31.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Video .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #Video .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-847.654 -182.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1121",
    "data-name": "Gruppe 1121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_511",
    "data-name": "Pfad 511",
    className: "cls-1",
    d: "M882.347,207.1h-.016l-24.436-.17a1.991,1.991,0,0,1-1.976-2l.092-13.14A1.991,1.991,0,0,1,858,189.81h.013l24.437.171a1.99,1.99,0,0,1,1.976,2l-.092,13.139a1.99,1.99,0,0,1-1.988,1.976ZM858,191.009a.79.79,0,0,0-.79.784l-.092,13.141a.8.8,0,0,0,.785.8l24.438.17h.006a.79.79,0,0,0,.789-.785l.092-13.139a.793.793,0,0,0-.785-.8l-24.437-.171Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_512",
    "data-name": "Pfad 512",
    className: "cls-1",
    d: "M867.251,202.7a.571.571,0,0,1-.3-.5l.053-7.533a.561.561,0,0,1,.89-.451l5.27,3.8a.561.561,0,0,1-.006.915l-5.323,3.729A.514.514,0,0,1,867.251,202.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_513",
    "data-name": "Pfad 513",
    className: "cls-2",
    d: "M872.477,209.245a13.995,13.995,0,1,1,0-21.581h2.876a15.995,15.995,0,1,0,0,21.581Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.12220e4be70b45ecf35f6591364dbc3f.svg";
export { ForwardRef as ReactComponent };